import React, { FC } from "react";
import { Routes, Route } from "react-router-dom";
import ReviewList from "./ReviewList";
import ReviewEdit from "./ReviewEdit";

const ReviewManagementPage: FC = () => (
  <Routes>
    <Route index element={<ReviewList />} />
    <Route path="edit/:id" element={<ReviewEdit />} />
  </Routes>
);

export default ReviewManagementPage;
